export default {
    namespaced: true,
    state: {
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload;
        }
    },
    actions: {
        getData({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}expired-logistik?size=${payload.size}&date=${payload.date}&category=${payload.category}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            })
        }
    }
}